<template>
    <div class="d-inline position-relative">
        <div class="d-inline">

            <span v-if="!value.changeStatusTo" class="lightest radius-normal px-2 py-1" :class="getReservationState(value.status).cssClass" >
                {{getReservationState(value.status).label}}
                <span v-if="getReservationState(value.status).allowChange && !disabled" @click.stop="toggleShowOptions" class="pointer"><i class="mr-0 ml-2 ico ico-arrow-bottom"></i></span>
            </span>

            <span v-else class="lightest radius-normal px-2 py-1" :class="getReservationState(value.changeStatusTo).cssClass" >
                {{getReservationState(value.changeStatusTo).label}}
                <span v-if="getReservationState(value.changeStatusTo).allowChange" @click.stop="toggleShowOptions" class="pointer"><i class="mr-0 ml-2 ico ico-arrow-bottom"></i></span>
            </span>

            <span
                v-if="getReservationState(value.status).extraLabel"
                @click="getReservationState(value.status).clickAction? getReservationState(value.status).clickAction(openReservation) : '' "
                class="ml-1"
                :class="{'underlined pointer': getReservationState(value.status).clickAction}"
            >
            {{getReservationState(value.status).extraLabel(value, formatTicketNumber)}}
            </span>

        </div>

        <div class="optionsHolder radius-normal p-2 border-light" v-if="optionsHolderOpen" v-click-outside="toggleShowOptions">

            <div
            v-for="option, id in getAllReservationStates"
            v-if="option.isOption"
            class="lightest radius-normal px-2 py-1 mb-2 text-center pointer"
            :class="option.cssClass"
            @click="selectOption(option, option.code)">
            {{option.label}}</div>

        </div>
    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'
import {mapActions, mapGetters} from 'vuex'

export default {
    data: function () {
        return {
            // statusLabels: {
            //     "-100": {
            //         label:"Stripe Error",
            //         color: 'color-6',
            //         cssClass: 'bg-color-6',
            //         allowChange: false,
            //         isOption: false,
            //         // onSelect: this.setReservationToCancel
            //     },
            //     "-5": {
            //         label:"Canceled",
            //         color: 'color-6',
            //         cssClass: 'bg-color-6',
            //         allowChange: true,
            //         isOption: true,
            //         // onSelect: this.setReservationToCancel
            //     },
            //     "1": {
            //         label:"Booked",
            //         color: 'color-3',
            //         cssClass: 'dark border-dark',
            //         allowChange: true,
            //         isOption: true,
            //     },
            //     "5": {
            //         label:"Pending",
            //         color: 'color-1',
            //         cssClass: 'bg-color-1',
            //         allowChange: true,
            //         isOption: true,
            //     },
            //     "20": {
            //         label:"Rebooked",
            //         color: 'color-2',
            //         cssClass: 'bg-color-2',
            //         extraLabel: function (reservation, formatTicketNumber) {
            //             return 'to '+formatTicketNumber(reservation.childBookingId);
            //         },
            //         clickAction: this.openReservation
            //     },
            //     "30": {
            //         label:"Rebooked",
            //         color: 'color-2',
            //         cssClass: 'bg-color-2',
            //         extraLabel: function (reservation, formatTicketNumber) {
            //             return 'from '+formatTicketNumber(reservation.parentBookingId);
            //         },
            //         clickAction: this.openReservation
            //     },
            // },
            optionsHolderOpen: false
        }
    },
    mixins:[
        reservationsMixin
    ],
    props:{
        value:{ // <- reservation
            type: Object,
        },
        disabled:{
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters([
            'getAllReservationStates',
            'getReservationState',
        ]),
    },
    methods: {
        ...mapActions([
            'closeModal',
            'openReservationById'
        ]),
        openReservation: function () {
            this.closeModal()
            if(this.value.parentBookingId){
                this.openReservationById(this.value.parentBookingId)
            }

            if(this.value.childBookingId){
                this.openReservationById(this.value.childBookingId)
            }
        },
        toggleShowOptions: function () {
            if(!this.disabled){
                this.optionsHolderOpen = !this.optionsHolderOpen
            }
        },
        selectOption: function (option, id) {
            // if(option.onSelect){
            //     option.onSelect()
            //     return false
            // }

            this.toggleShowOptions()
            //this changes the reservation immediatly wich is wrong
            // this.value.status = id // <- Set reservation status

            // Now we take note of the desired future status and only change it on save (update) reservation
            // if the reservation is from GetYourGide AND we are changing it to "canceled" the status should be -6 (pending cancelation)
            // in all the other cases we set to -5 as normal
            if(this.value.channelType == 202 && id == "-5"){
                this.$set(this.value, 'changeStatusTo', "-6")
            } else {
                this.$set(this.value, 'changeStatusTo', id)
            }

            this.applyChanges()
        },
        applyChanges: function () {
            this.$emit('value', this.value)
        },
        triggerCancelReservation: function() {
            this.eventHub.$emit('cancelReservation')
        }
    }
}
</script>

<style lang="scss" scoped>
.optionsHolder{
    position: absolute;
    background: #FFF;
    top: 100%;
    left: 0;
    z-index: 5;
    width: 150px;
    margin-top: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// changeStatusBtn.vue?783b405c